import React, { useRef, useState } from "react";
import styles from "./ai-chat-assistant-panel.scss";
import { MdAutoAwesome } from "react-icons/md";
import { ChatInput } from "app/components/ai-chat-assistant/components/chat-input";
import { useAiChatAssistantHooks } from "app/components/ai-chat-assistant/hooks/use-ai-chat-assistant-hooks";
import { OnClickOutside } from "ui/common/on-click-outside";
import { ChatMessages } from "app/components/ai-chat-assistant/components/chat-messages";
import { updateCaseDraftAction } from "app/components/ai-chat-assistant/hooks/draft-action";
import { ElementLoader } from "ui/common/element-loader/element-loader";

const CHAT_WIDTH = 370;
const CHAT_OFFSET = 22;

export const AiChatAssistantPanel  = (props) => {
  const {
    children,
    aiChatFeatureFlag,
    aiChatContext,
    aiChatInputFieldsDataTags,
    aiChatOutputFieldsDataTags,
    aiChatTitleText,
    aiChatPlaceHolderText
  } = props;
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [openLeft, setOpenLeft] = useState(false);
  const iconRef = useRef<HTMLDivElement>(null);
  const { dataTag } = props.componentDescriptor;
  const context = [
    {
      description: "context",
      value: aiChatContext
    },
    {
      description: "inputDataTags",
      value: aiChatInputFieldsDataTags
        ? aiChatInputFieldsDataTags.split(",")
        : []
    },
    {
      description: "outputDataTags",
      value: aiChatOutputFieldsDataTags
        ? aiChatOutputFieldsDataTags.split(",")
        : []
    }
  ];
  const {
    running,
    inputText,
    setInputText,
    send,
    abortChat,
    translation,
    onKeyDown,
    messages,
    saveDraft,
    aiChatFeature
  } = useAiChatAssistantHooks(
    context,
    false,
    updateCaseDraftAction,
    dataTag,
    aiChatFeatureFlag
  );

  const handleHide = () => {
    if (isChatOpen) {
      setIsChatOpen(false);
    }
  };

  const handleToggleChat = () => {
    setIsChatOpen((currentIsChatOpen) => {
      if (!currentIsChatOpen && iconRef.current) {
        const iconRect = iconRef.current.getBoundingClientRect();
        const chatRightEdge = iconRect.right + CHAT_OFFSET + CHAT_WIDTH;

        setOpenLeft(chatRightEdge > window.innerWidth);
      }

      return !currentIsChatOpen;
    });
  };
  if (!aiChatFeature) {
    return null;
  }
  return (
    <div className={`${styles.aiChatAssistantContainer}`}>
      {children}
      <div className={styles.aiChatAssistant}>
        <div
          ref={iconRef}
          className={styles.aiChatAssistantIcon}
          onClick={handleToggleChat}
        >
          <MdAutoAwesome />
        </div>
        {isChatOpen && (
          <OnClickOutside onClickOutside={handleHide}>
            <div
              className={`${styles.aiChatAssistantChat} ${openLeft ? styles.aiChatAssistantChatLeft : ""}`}
            >
              <div className={styles.aiChatAssistantChatHeader}>
                {aiChatTitleText}
              </div>
              <div className={styles.aiChatAssistantChatContent}>
                <ChatMessages
                  messages={messages}
                  running={running}
                  endRef={undefined}
                  translation={translation}
                  userMessageVariant="lighter"
                  className={styles.aiChatAssistantMessages}
                />
              </div>
              {saveDraft && (
                <div className={styles.elementLoader}>
                  <ElementLoader />
                </div>
              )}
              <div className={styles.aiChatAssistantChatFooter}>
                <ChatInput
                  inputText={inputText}
                  setInputText={setInputText}
                  send={send}
                  running={running}
                  placeholder={aiChatPlaceHolderText}
                  abortChat={abortChat}
                  onKeyDown={onKeyDown}
                  className={styles.aiChatAssistantChatInput}
                />
              </div>
            </div>
          </OnClickOutside>
        )}
      </div>
    </div>
  );
};

